import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { getTranslation } from '../translations';
import './Hero.css';

const Hero = () => {
  const { language } = useLanguage();
  const t = getTranslation(language);

  return (
    <section className="hero">
      <div className="hero-container">
        <motion.div
          className="hero-content"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <div className="hero-eyebrow">{t.hero.eyebrow}</div>
          
          <h1 className="hero-title">
            {t.hero.title}
          </h1>

          <p className="hero-description">
            {t.hero.description}
          </p>

          <div className="hero-cta">
            <a href="#contact" className="btn btn-primary">
              {t.hero.getEarlyAccess}
            </a>
            <a href="#contact" className="btn btn-secondary">
              {t.hero.contactSales}
            </a>
          </div>
        </motion.div>

        <motion.div
          className="hero-visual"
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          {/* SafeClaw Product Card */}
          <Link to="/safeclaw" className="hero-safeclaw-card">
            <div className="safeclaw-card-glow" />
            <div className="safeclaw-card-header">
              <span className="safeclaw-new-badge">
                <span className="safeclaw-badge-dot" />
                NEW
              </span>
              <span className="safeclaw-version">v0.1.1</span>
            </div>
            <div className="safeclaw-card-body">
              <div className="safeclaw-card-title-row">
                <img 
                  src="./safeclaw_logo_trimmed.png" 
                  alt="SafeClaw" 
                  className="safeclaw-card-logo"
                />
                <h3 className="safeclaw-card-title">
                  Safe<span className="safeclaw-highlight">Claw</span>
                </h3>
              </div>
              <p className="safeclaw-card-desc">
                {t.hero.safeClawDesc || (language === 'zh' 
                  ? '更安全、更强大的 OpenClaw 国产替代方案' 
                  : 'A safer, enhanced alternative to OpenClaw')}
              </p>
              <div className="safeclaw-card-features">
                <div className="safeclaw-feature-chip">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="14" height="14"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
                  {language === 'zh' ? '多层防护' : 'Multi-Layer Security'}
                </div>
                <div className="safeclaw-feature-chip">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="14" height="14"><rect x="2" y="3" width="20" height="14" rx="2" ry="2"/><line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/></svg>
                  {language === 'zh' ? '本地部署' : 'Local Deploy'}
                </div>
                <div className="safeclaw-feature-chip">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="14" height="14"><path d="M22 11.08V12a10 10 0 11-5.93-9.14"/><path d="M22 4L12 14.01l-3-3"/></svg>
                  {language === 'zh' ? '开源可控' : 'Open Source'}
                </div>
              </div>
            </div>
            <div className="safeclaw-card-footer">
              <span className="safeclaw-learn-more">
                {language === 'zh' ? '了解更多' : 'Learn More'}
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="16" height="16"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
              </span>
            </div>
          </Link>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;
